import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Col, Modal } from "antd";
import {
  FileAddOutlined,
  EditOutlined,
  DeleteOutlined,
  DownloadOutlined,
} from "@ant-design/icons";

import { useEditorContext } from "../../hooks/useEditorContext";
import { AddDocumentModal } from "../ModalForm";
import DocumentAuditMetaBlock from "./DocumentAuditMetaBlock";

import PDFPreview from "../../components/PdfPreview";

interface Documents {
  groupId?: any;
  memberId?: any;
  documents: any;
  handleAddDocument?: Function;
  handleDownloadDocument?: any;
  handleDeleteDocument: Function;
}

const DocumentList: React.FC<Documents> = ({
  groupId,
  memberId,
  documents,
  handleAddDocument,
  handleDownloadDocument,
  handleDeleteDocument,
}) => {
  const { setEditorContent, setEditorUpdate } = useEditorContext();
  const [show, setShow] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [documentId, setDocumentId] = useState("");

  const navigate = useNavigate();

  const handleAdd = () => {
    if (memberId) {
      setShow(true);
    } else {
      setEditorUpdate(false);
      setEditorContent("");
      navigate(`/groups/${groupId}/document`);
    }
  };

  const handleDownload = (document: any) => {
    handleDownloadDocument(document);
  };

  const handleEdit = (document: any) => {
    setEditorContent(document);
    setEditorUpdate(true);
    navigate(`/groups/${groupId}/document`);
  };

  const handleOk = (id: string) => {
    setIsModalOpen(false);
    handleDeleteDocument(id);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const showDeleteModal = (id: string) => {
    setIsModalOpen(true);
    setDocumentId(id);
  };

  const showModal = () => {
    setShow(!show);
  };

  return (
    <>
      {documents.map((document: any) => (
        <Col xs={24} sm={12} md={8} lg={6} key={document.id}>
          <div className="document-item">
            <h5 title={document?.Name}>{document ? document.Name : ""}</h5>
            {memberId && (
              <>
                <DocumentAuditMetaBlock document={document} />
                <div
                  style={{
                    width: "100%",
                    flex: 1,
                    minHeight: 120,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: "8px",
                  }}
                >
                  <PDFPreview pdfUrl={document && document.Link} />
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "12px",
                    width: "100%",
                  }}
                >
                  <DownloadOutlined
                    className="document-edit"
                    onClick={() => handleDownload({ ...document })}
                    title="Download"
                  />
                  {groupId && (
                    <EditOutlined
                      className="document-edit"
                      onClick={() => handleEdit({ ...document })}
                      title="Edit"
                    />
                  )}
                  <DeleteOutlined
                    onClick={() => showDeleteModal(document.id)}
                    className="document-delete"
                    title="Delete"
                  />
                </div>
              </>
            )}

            {!memberId && groupId && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "12px",
                  width: "100%",
                  marginTop: "auto",
                }}
              >
                <EditOutlined
                  className="document-edit"
                  onClick={() => handleEdit({ ...document })}
                  title="Edit"
                />
                <DeleteOutlined
                  onClick={() => showDeleteModal(document.id)}
                  className="document-delete"
                  title="Delete"
                />
              </div>
            )}
          </div>
        </Col>
      ))}

      <Col xs={24} sm={12} md={8} lg={6} onClick={handleAdd}>
        <div className="document-item-add" title="Add new document">
          <FileAddOutlined className="document-icon" />
        </div>
      </Col>

      <AddDocumentModal
        show={show}
        showModal={showModal}
        handleAdd={handleAddDocument}
        memberId={memberId}
      />

      <Modal
        title="Confirm Remove"
        open={isModalOpen}
        onOk={() => handleOk(documentId)}
        onCancel={handleCancel}
      >
        <p>Are you sure you want to remove this document?</p>
      </Modal>
    </>
  );
};

export default DocumentList;
